/**
 * UTC calendar-day helpers. The whole app treats "today" as the UTC date
 * (`new Date().toISOString().split('T')[0]`); these keep that consistent and
 * make streak arithmetic (yesterday / gap detection) exact.
 */
/** UTC calendar day (YYYY-MM-DD) for a date; defaults to now. */
export function utcDateString(date = new Date()) {
    return date.toISOString().split('T')[0];
}
/** The UTC calendar day `delta` days from `ymd` (negative for earlier). */
export function addUtcDays(ymd, delta) {
    const d = new Date(`${ymd}T00:00:00.000Z`);
    d.setUTCDate(d.getUTCDate() + delta);
    return utcDateString(d);
}
/** Whole calendar days from `aYmd` to `bYmd` (b − a); 0 for the same day. */
export function daysBetween(aYmd, bYmd) {
    const a = Date.parse(`${aYmd}T00:00:00.000Z`);
    const b = Date.parse(`${bYmd}T00:00:00.000Z`);
    return Math.round((b - a) / 86_400_000);
}
